/* ===========================================================================
   pocket-club-m1.js · R1C-M1 — Pocket Club · Mobile Director's Cut
   ---------------------------------------------------------------------------
   Deliberately tiny. This file owns NO state that another module already owns
   (cart, selection, films, loader, menu, consent are untouched). It adds two
   fail-safe mobile behaviours:

     1. keyboard avoidance — while a text control owns focus on a phone, the
        commerce dock stands down (class consumed by pocket-club-m1.css);
     2. a `Save-Data` introspection flag on <html>, so QA and CSS can verify
        the reduced-delivery state without sniffing the connection twice.

   Idempotent (guarded), and everything is wrapped so a failure degrades to
   exactly the R1C behaviour. Without JavaScript nothing is lost.
   =========================================================================== */

(() => {
  if (window.__tosPocketClubM1) return;
  window.__tosPocketClubM1 = true;

  try {
    const mobile = window.matchMedia("(max-width: 700px)");

    try {
      if (navigator.connection?.saveData === true) {
        document.documentElement.dataset.m1SaveData = "true";
      }
    } catch {
      /* connection info unavailable — nothing to flag */
    }

    const EDITING =
      "input:not([type='checkbox']):not([type='radio']):not([type='button']):not([type='submit']), textarea, select, [contenteditable='true']";

    const sync = () => {
      const active = document.activeElement;
      const editing = Boolean(active && typeof active.matches === "function" && active.matches(EDITING));
      document.body.classList.toggle("m1-keyboard-open", editing && mobile.matches);
    };

    document.addEventListener("focusin", sync, true);
    /* focusout fires before the next focusin; defer so a field→field move
       does not flash the dock back for one frame. */
    document.addEventListener(
      "focusout",
      () => {
        window.setTimeout(sync, 80);
      },
      true,
    );
    mobile.addEventListener?.("change", sync);
  } catch {
    /* fail-safe: M1 behaviours are enhancements only; R1C keeps working */
  }
})();
